import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({

    container: {
        cursor: 'pointer',
        marginTop: '5px',
        "&:hover, &:focus": {
            backgroundColor: '#afa'
        },
    },
    fotoCapa: {
        width: '250px',
        height: '180px'
    },

})

const MuralCardV2 = ({ mural }) => {

    const classes = useStyles();
    const history = useNavigate();

    return (
        <Grid
            className={classes.container}
            direction='column'
            container
            spacing={3}
            justifyContent='center'
            alignItems='center'
            onClick={() => history('/mural-foto-usuario', { state: { mural } })}
        >
            {mural.fotoCapa ?
                <Grid>
                    <img
                        className={classes.fotoCapa}
                        src={mural.fotoCapa}
                        alt=''
                    />

                </Grid> : ''
            }
            <Grid>
                <Typography variant="body1">
                    {mural.descricao.substring(0, 30)}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default MuralCardV2;